import { render, staticRenderFns } from "./GreenMailSVG.vue?vue&type=template&id=23cb0a1f&scoped=true&"
import script from "./GreenMailSVG.vue?vue&type=script&lang=js&"
export * from "./GreenMailSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb0a1f",
  null
  
)

export default component.exports